import { Injectable } from '@angular/core';
import { PlatformService } from '../platform/platform.service';

@Injectable()
export class Storage {
    constructor(private platform: PlatformService) { }

    public set(key: string, data: string, useCookie?: boolean) {
        if (this.platform.localStorage && !useCookie) {
            try {
                this.platform.localStorage.setItem(key, data);
                return;
            } catch (err) { // 在safari的匿名模式的时候会报错
                // go ahead
            }
        }
        this.platform.document.cookie = key + '=' + data;
    }

    public get(key: string, useCookie?: boolean) {
        if (this.platform.localStorage && !useCookie) {
            const value = this.platform.localStorage.getItem(key);
            if (value) {
                return value;
            }
        }
        // 从cookie里面取
        const reg = new RegExp(key + '=([^;]*)');
        const m = this.platform.document.cookie.match(reg);
        if (m && m.length > 1) {
            return m[1];
        }
        return null;
    }

    public remove(key: string, useCookie?: boolean) {
        if (this.platform.localStorage && !useCookie) {
            const val = this.platform.localStorage.getItem(key);
            if (val) {
                this.platform.localStorage.removeItem(key);
                return val;
            }
        }
        // 从localstorage里没发现这个key
        const exp = new Date();
        exp.setTime(exp.getTime() - 1);
        const value = this.get(key);
        this.platform.document.cookie = key + '=' + value + ';expires=' + exp.toUTCString();
        return value;
    }
}

// export const storage = new Storage();
